module.exports = __webpack_public_path__ + "static/media/promo.a14bdb0e.png";